import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  scrollToId?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth,
  scrollToId,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 shadow-sm hover:shadow-md active:scale-95';
  const variants = {
    primary: 'bg-[#E76F51] text-white hover:bg-[#d66245] px-8 py-4 text-lg md:text-xl',
    secondary: 'bg-white text-[#1E2A4A] border-2 border-[#1E2A4A] hover:bg-[#FBF7F0] px-6 py-3 text-base md:text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (scrollToId) {
      e.preventDefault();
      const element = document.getElementById(scrollToId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) onClick(e);
  };
  return <motion.button whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={handleClick} {...props} data-id="element-267">
      {children}
    </motion.button>;
}